export default "__VITE_ASSET__BmVB33dW__"